<script lang="ts">
  import type {SvelteComponent} from 'svelte';
  import {slide} from 'svelte/transition';
  import {horizontalSlide} from '../../../transitions/transitions';
  import editorStore, {EditorStore} from '../editor.store';

  function removePopoverComponent() {
    editorStore.setActiveComponent(null);
    editorStore.removePopoverComponent('Quick Edit');
  }

  function getComponentFromStore(store: EditorStore) {
    if (store.popoverComponent) {
      if (store.popoverComponent.component) return store.popoverComponent.component;
      return store.popoverComponent;
    }
    return null;
  }

  function getComponentArgumentsFromStore(store: EditorStore) {
    if (store.popoverComponent) {
      if (store.popoverComponent.args) return store.popoverComponent.args;
    }

    return null;
  }

  $: comp = getComponentFromStore($editorStore);
  $: args = getComponentArgumentsFromStore($editorStore);
</script>

{#if $editorStore.popoverComponent}
  <div
    in:horizontalSlide={{duration: 100}}
    out:horizontalSlide={{duration: 100}}
    class="absolute left-0 top-0 flex h-full w-full flex-col bg-white text-black"
    id="popover-view"
  >
    <div class=" flex bg-white text-right text-black">
      <div
        on:click={removePopoverComponent}
        on:keypress={removePopoverComponent}
        class="cursor-pointer px-6 py-6 transition-all"
      >
        <span class="inline-block text-sm text-gray-500">
          <i class="fa-solid fa-chevron-left" aria-hidden="true" /> Back
        </span>
      </div>
      {#if $editorStore.activePopoverLabel}
        <span class="block pl-4 text-xs font-extrabold uppercase text-white">{$editorStore.activePopoverLabel}</span>
      {/if}
    </div>
    <div class="no-scrollbar flex-grow">
      <svelte:component this={comp} bind:this={comp} {...args} />
    </div>
  </div>
{/if}

<style lang="postcss">
  #popover-view {
    z-index: 100;
  }
</style>
